import { render, staticRenderFns } from "./PromoterEventLink.vue?vue&type=template&id=637b5598&"
import script from "./PromoterEventLink.vue?vue&type=script&lang=js&"
export * from "./PromoterEventLink.vue?vue&type=script&lang=js&"
import style0 from "./PromoterEventLink.vue?vue&type=style&index=0&id=637b5598&prod&scss=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports